var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle, _path32, _ellipse2, _path33, _path34, _path35, _path36, _circle2, _circle3, _path37, _ellipse3, _path38, _path39, _path40, _path41, _circle4, _path42, _path43, _path44, _polygon2, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _circle5, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _polygon3, _polygon4, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _circle6, _path77, _path78, _path79, _g2, _path80, _path81;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 990.32,
    height: 727.03,
    viewBox: "0 0 990.32 727.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "acc8b6a5-9f39-4130-a42e-d6ce30e2b206-869",
    x1: 654.16,
    y1: 770.88,
    x2: 654.16,
    y2: 513.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "by_my_car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.46,378.23c20.84,47.07-5.75,101.29-37,142.16-10.48,13.68-22,28-23.47,45.22-1.75,21,12.47,40.31,29.35,52.93,30.77,23,72.81,30.11,109.43,18.51,31.65-10,58.26-32.67,90.18-41.81,53.42-15.29,110,10.06,155.71,41.63,32.35,22.34,67,49.5,106,44.73,27.46-3.36,50.76-22.63,66.56-45.33,7.63-11,14.27-23.23,25.39-30.63,6.61-4.4,14.37-6.73,22.14-8.39,70.9-15.15,146.13,21.83,216.09,2.81,47.25-12.85,84.93-50.2,108.35-93.19s34.36-91.55,43.47-139.66c6.47-34.19,11.84-71.08-3-102.54-15.74-33.28-52.17-53.45-88.78-57.22s-73.34,6.68-107.07,21.42c-42.15,18.43-83.46,44.23-129.47,44.32-31.33.06-61.2-12-91.16-21.13C619,236.73,567,229.11,515.07,222.08c-49.69-6.73-99.86-13-149.85-9-35.37,2.81-66.6,16.33-100.92,22.58-22.37,4.08-44.85,1-66.8,7.91-27,8.45-54.84,28.06-56.33,58.91C139.76,331.81,165.4,353.24,176.46,378.23Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.73,269.64c-5,1.44-11.21,5.16-14.25,15.37-6,20,7.88,33.68,3.33,54.45a40.61,40.61,0,0,1-7,15.27c-5.57,7.55-11.63,11.13-17.49,16.42a52.18,52.18,0,0,0-15.37,25.24,69.86,69.86,0,0,0-.69,32.81c2.09,9.06,5.65,15.65,8.75,23a169.86,169.86,0,0,1,9,29,70.52,70.52,0,0,1,2,14.71c.1,6.23-.87,13-1.82,19.68l-8.47,59.11c-1.13,7.87-2.27,15.87-2.31,23.36-.06,8.65,1.33,16.08,2.71,23.33,3,15.64,6.17,31.87,13,40.12s18.41,5.39,25.54-11.45c6.78-16,6.92-37.4,12.9-54.52,9.42-27,28.16-30.6,38.55-56.33,10-24.68,6.92-55,12-83.12,3.62-20.17,11.33-38.57,15.9-58.5,6.57-28.71,5.92-58.51.67-80.57s-14.67-37.21-25.07-48.7c-4.41-4.87-9.12-9.2-14.66-9.63-5.89-.45-11,7-16.85,9.19C816.32,270.41,809.56,267.7,802.73,269.64Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.62,260.09s-10,255.28-51.93,405.82",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.22,286.26S833,327.07,824.55,404.83",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6,402.38s73.6,14.8,68.14,58.82",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.77,316.41S850,342.48,823.46,416.32",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.66,539.58s-20.32,16-36.63-39.81",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763,572.13s41.44-5.41,45.26-31.37",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.9,98.42c-10.26,1.52-22.6,6.27-27.67,20.94-9.95,28.76,20.31,50.53,13.34,80.58-2.09,9-7.24,16.32-12.67,21.66-10.64,10.46-22.75,15-34.25,22.1s-23.44,18.24-28.83,35.35c-5.19,16.46-2.94,34.65,2.45,48.24s13.55,23.72,20.84,34.9a236.44,236.44,0,0,1,22.15,43.71c2.61,6.73,5,13.83,5.85,21.89.94,9.19-.25,19.08-1.43,28.76l-10.52,86c-1.4,11.45-2.81,23.1-2,34.13.91,12.73,4.67,23.83,8.38,34.67,8,23.38,16.56,47.67,31.63,60.62s38.75,10.12,51.49-13.84c12.13-22.81,9.9-54.26,20.24-78.76,16.3-38.61,54.65-41.73,73.1-78.38,17.71-35.16,7.8-80.14,14.91-121,5.1-29.28,18.89-55.45,26-84.26,10.2-41.51,5.33-85.46-8.17-118.57s-34.78-56.54-57.66-74.69c-9.7-7.69-20-14.64-31.48-15.92-12.24-1.36-22,8.94-33.79,11.53C931.11,101.15,916.81,96.36,902.9,98.42Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M967.76,88.12s9.65,374.76-59.36,591.47",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M874.83,121.16s97.62,65.42,89.26,178.92",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M810.75,287.71s154.08,30.52,148,94.69",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.88,176.42s-58.56,34.86-104.69,140.45",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.1,501.61s-40.16,21.14-80.53-63",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M856.47,539.16s85.13-3.06,90-40.82",
    transform: "translate(-104.84 -86.48)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 488.21,
    cy: 584.71,
    rx: 427.67,
    ry: 41.08,
    fill: "#f4b536",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.09,622.29s8.38,11-3.87,27.5S145.87,680.31,150,690.62c0,0,18.48-30.73,33.52-31.16S188.64,640.77,172.09,622.29Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.09,622.29a13.57,13.57,0,0,1,1.71,3.44c14.68,17.24,22.49,33.33,8.39,33.74-13.14.38-28.9,23.87-32.68,29.81a12.74,12.74,0,0,0,.45,1.35s18.48-30.73,33.52-31.16S188.64,640.77,172.09,622.29Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.67,636.26c0,3.86-.43,7-1,7s-1-3.13-1-7,.54-2,1.07-2S187.67,632.4,187.67,636.26Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffd037"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193,640.86c-3.39,1.85-6.34,3-6.59,2.49s2.28-2.35,5.67-4.19,2.05-.5,2.31,0S196.4,639,193,640.86Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffd037"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.82,622.29s-8.38,11,3.87,27.5S154,680.31,150,690.62c0,0-18.48-30.73-33.52-31.16S111.28,640.77,127.82,622.29Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.82,622.29a13.57,13.57,0,0,0-1.71,3.44c-14.68,17.24-22.49,33.33-8.39,33.74,13.14.38,28.9,23.87,32.68,29.81a12.74,12.74,0,0,1-.45,1.35s-18.48-30.73-33.52-31.16S111.28,640.77,127.82,622.29Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.25,636.26c0,3.86.43,7,1,7s1-3.13,1-7-.54-2-1.07-2S112.25,632.4,112.25,636.26Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffd037"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9,640.86c3.39,1.85,6.34,3,6.59,2.49s-2.28-2.35-5.67-4.19-2.05-.5-2.31,0S103.51,639,106.9,640.86Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffd037"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.91,689.19s23.43-.72,30.49-5.75,36-11,37.79-3,35.21,40.11,8.76,40.32-61.46-4.12-68.51-8.41S114.91,689.19,114.91,689.19Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#a8a8a8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.43,718c-26.45.21-61.46-4.12-68.51-8.41-5.37-3.27-7.51-15-8.22-20.41l-.78,0s1.48,18.9,8.53,23.19S165.51,721,192,720.79c7.64-.06,10.27-2.78,10.13-6.8C201,716.42,198.11,717.94,192.43,718Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M419.87,537.43s117.25-74.91,198.31-74.91c0,0,97.59-15.2,203.74,10.49s145.36,59,174.79,49.22l-123.64,3.62Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M419.87,537.43s117.25-74.91,198.31-74.91c0,0,97.59-15.2,203.74,10.49s145.36,59,174.79,49.22l-123.64,3.62Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "867.68 565.6 152.6 565.6 172.26 486.83 293.86 454.5 867.68 469.58 867.68 565.6",
    fill: "#121c3f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.16,602.86V628S988.93,643.4,987,655.46c0,0-30.4,7.72-39.08,7.72-.79,0-1.65,0-2.55.09a72.18,72.18,0,0,0,3.17-11.19,73.7,73.7,0,1,0-144.56,0,73.57,73.57,0,0,0,4.69,15H767.45s-.38.13-1,.4c-2.21,1-7.42,3.64-8.17,7.79H416.67l-7-.06a72.26,72.26,0,0,0,4-7.74,71.41,71.41,0,0,0,4.86-15.37A73.76,73.76,0,1,0,272.46,637.6a74.4,74.4,0,0,0,1.42,14.47,73.53,73.53,0,0,0,8.74,22.9c-4.88-1.19-15.53-4.57-15.53-4.57s-45.35-4.82-56.93-15l1.75-1.21,7.42-5.07-3.38-13a8,8,0,0,1-1-1.78c-.9-2.17-1.69-6.2,1.49-11.26,4.82-7.72,2.41-35.22,2.41-35.22s65.62-45.35,194.93-55.49c0,0,3.09,2.4,9.47,2.9,4.32.35,10.15-.18,17.56-2.9,0,0,10.61,4.82,56-21.23,0,0,77.21-53.08,178.54-48.24,0,0,104.22-6.28,193,28,38.26,14.76,67.37,22.63,88.12,26.79,19.16,3.85,31.19,4.56,36.7,4.62h.12c1.8,0,2.87,0,3.25,0h.16s0,11.49.61,25.06v.07c.22,4.72.52,9.69.94,14.52l0,.3c1.16,13.45,3.16,25.67,6.63,28.09Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#2856b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.28,586.76s29.07-22.68,65.26-17.85c0,0-32.93,26.06-47.77,24.37l-2.53-2.17-15,.84S227,588.45,229.28,586.76Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5,626v13.39s-1,12.79-12.55,13.27l-33,1.63,7.41-5.07-3.38-13a7.73,7.73,0,0,1-1-1.77c3-2.76,10.07-7.42,24.45-8.42Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M411.06,569.88l25.33-1s-10.25,8.08-17.49,8.81S411.06,569.88,411.06,569.88Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M464.38,646.72S693.45,614.87,748.82,625c0,0,16.28,1.09,22.44,7.6s0,2.29,0,2.29Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M592.61,557.33s2.9-5.43,7.6-5.55l30.52-1.57s-.48,4.22-5.91,5.79Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#18218a",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M769.21,548.16s2.9-5.43,7.6-5.55L807.33,541s-.48,4.22-5.91,5.79Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#18218a",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M665,473.76l-23.42,61.42-84.44.09-21.74,0-18.91,0-16.35,0-18.52,0s11.28-8.28,29.45-18.83c6-3.5,12.81-7.24,20.2-11,6.8-3.48,14.12-7,21.81-10.34,6-2.64,12.32-5.18,18.78-7.55C601.15,476.84,634.07,469.65,665,473.76Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M797.68,518.61s-35.28,5.23-68.95,9.1c-12.87,1.48-25.5,2.76-35.84,3.47l-1.44.1c-4,.26-7.71.43-10.86.49-5,.09-8.74-.13-10.61-.73l9.73-58.75s12,.13,29.75,1l3.88.21c3.69.21,7.58.45,11.64.73,5.8.4,11.91.88,18.21,1.46,30.42,2.79,64.88,7.8,86.7,16.82C876.32,511.73,797.68,518.61,797.68,518.61Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M960.28,548.16v15.68s-25.33.36-19.9-4.7a77.61,77.61,0,0,0,9.53-11Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M998.23,562.24l-20.57,1.61V545s9.53-13.39,19.06,1.45l.55.87Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#8cd0f3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 241.39,
    cy: 551.12,
    r: 58.87,
    fill: "#182a7c"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M393.45,637.55a47.38,47.38,0,1,1-1-9.6A47.48,47.48,0,0,1,393.45,637.55Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.32,
    cy: 551.06,
    rx: 40.59,
    ry: 40.69,
    fill: "#18218a",
    opacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M359.74,592.12v1.72l-13.51,44.73-10.84-47.19a47.49,47.49,0,0,1,24.35.74Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M359.64,683a47.5,47.5,0,0,1-23.81.82l10.39-45.25Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M393.45,637.55a47.48,47.48,0,0,1-2.26,14.54H391l-44.73-13.51,46.26-10.62A47.74,47.74,0,0,1,393.45,637.55Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M346.23,638.57l-44.73,13.51h-.35a47.88,47.88,0,0,1-1.29-24.16Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.32,
    cy: 551.06,
    r: 5.19,
    fill: "#182a7c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.06,
    cy: 551.12,
    r: 58.87,
    fill: "#182a7c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M923.13,637.55a47.38,47.38,0,1,1-1-9.6A47.48,47.48,0,0,1,923.13,637.55Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 771,
    cy: 551.06,
    rx: 40.59,
    ry: 40.69,
    fill: "#18218a",
    opacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M889.41,592.12v1.72L875.9,638.57l-10.84-47.19a47.49,47.49,0,0,1,24.35.74Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M889.32,683a47.5,47.5,0,0,1-23.81.82l10.39-45.25Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M923.13,637.55a47.48,47.48,0,0,1-2.26,14.54h-.23L875.9,638.57l46.26-10.62A47.74,47.74,0,0,1,923.13,637.55Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M875.9,638.57l-44.73,13.51h-.35a47.88,47.88,0,0,1-1.29-24.16Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#3f8ffe"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 771,
    cy: 551.06,
    r: 5.19,
    fill: "#182a7c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M531.28,505.5l-14.79,29.81-16.35,0,10.93-18.81C517.1,513,523.89,509.27,531.28,505.5Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M571.86,487.61l-14.73,47.67-21.74,0,17.7-40.14C559.13,492.52,565.41,490,571.86,487.61Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M725,474.28l-32.09,56.91-1.44.1c-4,.26-7.71.43-10.86.49l28.87-58.43,3.88.21C717,473.76,720.92,474,725,474.28Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#fff",
    opacity: 0.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.34 448.63 359.02 574.82 512.03 571.47 537.15 449.18 377.34 448.63",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M766.46,667.44c-2.21,1-7.42,3.64-8.17,7.79H416.67l-7-.06a72.26,72.26,0,0,0,4-7.74Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#18218a",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M471.11,758.63c2.33-2.17,4.52-4.73,5.2-7.84s-.65-6.85-3.63-8c-3.33-1.28-6.9,1-9.6,3.37s-5.8,5-9.33,4.5a14.21,14.21,0,0,0,4.39-13.3,5.56,5.56,0,0,0-1.22-2.7c-1.85-2-5.21-1.13-7.42.43-7,5-9,14.53-9.05,23.15-.71-3.11-.11-6.35-.13-9.54s-.89-6.72-3.58-8.44a10.79,10.79,0,0,0-5.46-1.28c-3.17-.12-6.7.2-8.86,2.52-2.69,2.88-2,7.71.35,10.88s5.9,5.16,9.17,7.35a20.34,20.34,0,0,1,6.55,6.25,6.19,6.19,0,0,1,.49,1.12h19.86A55.36,55.36,0,0,0,471.11,758.63Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M886.2,775.45a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,886.2,775.45Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M951.2,807.26a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,951.2,807.26Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f4b536"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M763.27,740.41s-3.49,1.9-5.08-8.86c-1-7-3.91-21.43-5.82-30.8l-.24-1.19a16.27,16.27,0,0,0,1.61-.6s-11.12-43-8.58-52.52,0-26.58,0-26.58l-6.67-22.46s-16.52-5.7-22.87-7.28-24.14-12.66-24.14-12.66a13.72,13.72,0,0,1,.86,1.11l-.71-.43a26.51,26.51,0,0,1-3.5-4,25.18,25.18,0,0,0,6.58-13.68,28.4,28.4,0,0,0-1.42-28.89,14.17,14.17,0,0,0,2.43-4.54,7.42,7.42,0,0,0,.27-2.32,6.17,6.17,0,0,0-3.48-6.13,6.07,6.07,0,0,0-4.78.05c-1.41.64-2.52,1.84-4.06,2.16-2.57.53-4.77-1.53-6.79-3.06a20.43,20.43,0,0,0-10.79-4,10.48,10.48,0,0,0-5,.66,20.11,20.11,0,0,0-4.14,3.11c-4.58,3.69-11,4.72-16.75,6.73-1.1.38-2.32,1-2.52,2a1.46,1.46,0,0,0,0,.6v0a1.48,1.48,0,0,0,.06.76c-10.72,1.8-21.21,9.94-21.21,9.94l-1.76,1.63a3.36,3.36,0,0,0-3.67.31l-3.54,2.78a3.33,3.33,0,0,0-.8,4.34l-25.89,24-.56.52v-.09s-20,15.19-20,25.94c0,7.77,6,12.56,9.27,14.63a24.8,24.8,0,0,0-6.46,10h0l0,.1,0,.14,0,.11,0,.12,0,.1,0,.11,0,.1,0,.1,0,.09,0,.09,0,.08,0,.09,0,.07,0,.11,0,.1,0,.06,0,.06v.44l0,.12,0,.24h0l0,.17,0,.17-.08.44,0,.18-.05.3,0,.12,0,.29,0,.21-.07.4h0l-.09.5,0,.1-.07.42,0,.2-.08.46,0,.12-.09.52,0,.23-.23,1.31v0l-.12.71,0,.12-.13.73,0,.1-.13.74v.06l-.14.78,0,.17-.14.77,0,.17-.13.76,0,.09-.15.86,0,.16-.34,1.92h0l-.17,1,0,.15-.17,1v.07l-.37,2,0,.17-.18,1,0,.14-.39,2.11,0,.09-.2,1.07,0,.09-.4,2.18,0,.14-.2,1.08,0,.08-.42,2.23,0,.12-.21,1.1,0,.08-.43,2.26,0,.09-.21,1.1,0,.09L555.9,660l0,.1-.22,1.09v.06l-.45,2.22v.06l-.22,1.08v.06l-.44,2.12,0,.09-.21,1,0,.09-.43,2,0,.07-.21,1,0,.1-.42,1.89v.05l-.2.89,0,.09q-.21.9-.41,1.74v0l-.2.82,0,.07q-.2.82-.39,1.57v0l-.19.72,0,.08-.18.69c-.8,3-1.5,5-2,5.47a5.62,5.62,0,0,0-1.17,1.84h0l-.08.2-.08.22-.07.22L548,688l-.07.23-.06.21-.06.24,0,.22-.05.24,0,.22q0,.24-.08.48l0,.2,0,.27,0,.21,0,.27,0,.21,0,.27,0,.21,0,.27v.2c0,.33,0,.65,0,1,0,.06,0,.12,0,.19s0,.17,0,.26,0,.13,0,.19,0,.17,0,.25,0,.12,0,.19,0,.16,0,.24v.18c0,.08,0,.16,0,.24v.16q0,.22,0,.43v1.58l0,.22v.63l3,.91s1.51.83,3.84,1.91c-.33,10.09-1.26,23.75-3.79,32.11-5.64.29-19.57.88-22.09-.13-3.18-1.27-23.51-4.43-17.15,10.12,2.66,6.1,8.45,10.7,14.27,14a17.78,17.78,0,0,1-2.2.57c-5.18,1-6.62,2.73-6.42,4.51-.37,3,4.73,6.35,5.15,6.56.64.32,22.23,3.8,27.32,2.21s25.73-5.38,25.73-5.38,0-.23,0-.63h0s-.28-6.22-1.06-12.12c2.34-.34,4.89-.65,7.37-.84a10.06,10.06,0,0,0,5.44,6.95c13.66,7,18.11-2.53,18.11-2.53s18.47,3.55,28.79,1c1.08,1,2,1.71,2.65,2.19,3.35,2.41,12.37,4.06,22.46,4.18a31.83,31.83,0,0,0,8.06-.23A74.68,74.68,0,0,0,680.36,761c12.15-3.15,14.82-14.45,15.4-19.58.48-.14.82-.64,1-1.58a4.55,4.55,0,0,0,.42-1.63,48.1,48.1,0,0,1,1.3-6.88l15,.84C720.18,744.33,726.1,754,726.1,754l10.16-1.27a58.69,58.69,0,0,1-11.75-12.66c-5.08-7.59-5.08-44-5.08-44L720,673.9l0,.23,0-1.07c.94,6.57,8.39,25.63,9.23,25.91.61.2,1.21.38,1.8.55l.54,1.42c4.24,11.24,15,40,15.76,44.54,1,5.7,40.66,7.91,49.55,5.06S763.27,740.41,763.27,740.41ZM621.6,614.49l-14.54,21.84c-5.22-9-10.66-17.28-15.58-22.76C604.38,614,619.25,614.46,621.6,614.49Zm-2.21-56a3.37,3.37,0,0,0,3.51-.39l1.24-1a3.33,3.33,0,0,0,.85-4.28l.74-.73a110.58,110.58,0,0,0,15.12-3.67,28.23,28.23,0,0,0,3.7,12.84,25.06,25.06,0,0,0,2.44,7.2c-2.28-.19-4.76-.32-7.13-.3a37.24,37.24,0,0,0-6.19.39c-7.62,1.27-8.58,15.19-8.58,15.19s-15.31,5.38-24.51,5.57a11.52,11.52,0,0,1-3.44-.51l-.93-.06,1.25-3.42s-.54.17-1.43.35q.43-.65.9-1.32C602.75,576,612.83,565.24,619.39,558.51ZM587.93,727.44a59,59,0,0,0-3.15,6.2c-3.61.7-8.53,1.09-11.14-1.14a6.5,6.5,0,0,0-4.18-1.47l.06-.12c1.8-3.45,3.33-11.18,4.53-19.18,5.82,0,11.35-4.87,11.35-4.87l7.33,2.51.27.51.18.33.29.54.18.34.29.53.19.34.29.52.19.34.28.51.19.34.29.51.19.33.29.5.18.32.29.5.18.31.28.49.18.31.29.49.17.28.29.48.17.28.29.48.15.25.3.49.11.18c.52.85,1,1.66,1.49,2.42l.07.11.28.44.12.19.25.4.14.21.23.36.14.23.21.33.15.23.2.31.14.22.18.28.14.22.17.26.14.22.16.24.14.21h0A64.41,64.41,0,0,1,587.93,727.44Z",
    transform: "translate(-104.84 -86.48)",
    fill: "url(#acc8b6a5-9f39-4130-a42e-d6ce30e2b206-869)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M793.36,748.74c-8.67,2.79-47.38.62-48.31-5-.74-4.47-11.23-32.6-15.37-43.6l-1.66-4.4,20.13-4.34s.74,3.53,1.76,8.56c1.86,9.18,4.67,23.35,5.67,30.15,1.55,10.53,5,8.67,5,8.67S802,745.95,793.36,748.74Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffbdc6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M684,566s-1.55,9.29,11.77,18,1.86,39.95,1.86,39.95l-9.85.55a24.21,24.21,0,0,1-25.46-21.92h0s5.57-9-4.65-32.21Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffbdc6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M626.44,554.57s-19.17,18.69-28.08,31.57a45.49,45.49,0,0,0-2.89,4.66c-6.5,12.39-21.62-7.75-16.39-14.71l3.61-3.37,34.76-32.4s23.85-18.58,35.92-5.26S626.44,554.57,626.44,554.57Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffbdc6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.18,
    cy: 463.29,
    r: 27.87,
    fill: "#a66477"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M555.53,731.08s-20.75,1.24-23.85,0S508.77,726.75,515,741s29.73,20.13,29.73,20.13l17-4.34Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#7679b4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M555.53,731.08s-20.75,1.24-23.85,0S508.77,726.75,515,741s29.73,20.13,29.73,20.13l17-4.34Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.05
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M629.54,670.08,671.19,687l23.69,50.32s.31,17.65-15.17,21.68-37.16,2.17-42.74-1.86-28.49-27.87-28.49-27.87Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#7679b4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M626.71,670.08l36.05,13.51,20.51,40.27s.27,14.13-13.13,17.35-32.17,1.73-37-1.49-24.66-22.31-24.66-22.31Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.05
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M590.83,731.08s-10.84,3.72-15.17,0-12.08.93-12.08.93L567,752.14s15.48-3.41,23.85-2.48Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffbdc6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M590.83,731.08s-10.84,3.72-15.17,0-12.08.93-12.08.93L567,752.14s15.48-3.41,23.85-2.48Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.05
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M597,709.41,587.11,706s-10.84,9.6-18,1.55,6.5-41.5,6.5-41.5l14.55-23.54,10.53,33.14,9.6,16.1Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#565388"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M597,709.41,587.11,706s-10.84,9.6-18,1.55,6.5-41.5,6.5-41.5l14.55-23.54,10.53,33.14,9.6,16.1Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.05
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "586.63 621.07 608.93 624.16 613.27 644.6 585.71 643.05 586.63 621.07",
    fill: "#565388"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "586.63 621.07 608.93 624.16 613.27 644.6 585.71 643.05 586.63 621.07",
    opacity: 0.05
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M660.2,595.45s9.29,35.61,39,9.91l8.05,102.19s-9.91,15.79-11.46,30-28.49-44-44.59-44.28-32.05-22.76-32.05-22.76l18.12-37.32Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M660.51,594.52s9.29,35.61,39,9.91l8.05,102.19s-9.91,15.79-11.46,30-28.49-44-44.59-44.28-32.05-22.76-32.05-22.76l18.12-37.32Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#f2f1f2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M655.55,571.6s-13-2.17-20.44-.93-8.36,14.86-8.36,14.86-21.06,7.43-28.18,5c0,0-35-2.48-35,8.05S574.73,614,574.73,614s48.59,1.64,48.93,1.55c11.15-3.1-.31,0-.31,0l-20.13,30.35,18.58,25.7,19.82-14.55s2.48-13.63,9-20.44c4.64-4.87,10.71-26.79,13.8-38.92a19.9,19.9,0,0,0-2.25-15.19Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M598.36,586.14a45.49,45.49,0,0,0-2.89,4.66c-6.5,12.39-21.62-7.75-16.39-14.71l3.61-3.37C581.37,588.7,594.38,587,598.36,586.14Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M623.35,614.34H623S634.5,611.24,623.35,614.34Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M654.62,571.6s-13-2.17-20.44-.93-8.36,14.86-8.36,14.86-21.06,7.43-28.18,5l1.24-3.41S580,593,582.16,573.15c0,0-19.51,14.86-19.51,25.39S573.8,614,573.8,614s48.59,1.64,48.93,1.55c11.15-3.1-.31,0-.31,0l-20.13,30.35,18.58,25.7,19.82-14.55s2.48-13.63,9-20.44c4.64-4.87,10.71-26.79,13.8-38.92a19.9,19.9,0,0,0-2.25-15.19Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#565388"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M718.42,672.25l0,1.7A3.7,3.7,0,0,1,718.42,672.25Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M749.91,700a35.39,35.39,0,0,1-20.23.18l-1.66-4.4,20.13-4.34S748.88,695,749.91,700Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M689.62,579.34s17.34,10.84,23.54,12.39,22.3,7.12,22.3,7.12l6.5,22s2.48,16.72,0,26-25.7,26.94-24.46,24.15l-.62,24.46s0,35.61,5,43-9.45-7.28-9.45-7.28-17.5-25.86-19.66-42.27S694,609.38,694,609.38l-3.1-4.34S697.36,588.32,689.62,579.34Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M690.55,579.34s17.34,10.84,23.54,12.39,22.3,7.12,22.3,7.12l6.5,22s2.48,16.72,0,26,8.36,51.41,8.36,51.41-10,4.62-23.85,0c-.93-.31-10.22-24.46-9-27.25l-.62,24.46s0,35.61,5,43a57.35,57.35,0,0,0,11.46,12.39l-9.91,1.24S695.81,705.38,693.64,689s1.24-79.59,1.24-79.59l-3.1-4.34S698.29,588.32,690.55,579.34Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#565388"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M606,728s-20.75-30-19.82-44c0,0-2.48,19.2-5.26,20.44S550.26,697,550.26,697s-1.24-9,1.86-12.08,12.7-60.39,12.7-60.39,3.41-15.48,18.27-16.41,48.31,74.63,48.31,74.63S636.35,728,606,728Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#7679b4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M557.08,687.11s.62,43.35-7.12,50.48,22.61,10.84,22.61,10.84-5.26-10.53-.93-18.89,7.12-42.43,7.12-42.43Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#ffbdc6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M558.62,737s-3.1-7.74-11.46-1.55c0,0-7.43,17.34-20.44,19.82s-1.86,9.91-1.24,10.22,21.68,3.72,26.63,2.17,25.08-5.26,25.08-5.26-.93-20.44-4-22S571.63,749.67,558.62,737Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.05
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M558.62,737.59s-3.1-7.74-11.46-1.55c0,0-7.43,17.34-20.44,19.82s-1.86,9.91-1.24,10.22,21.68,3.72,26.63,2.17S577.2,763,577.2,763s-.93-20.44-4-22S571.63,750.28,558.62,737.59Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#7679b4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M616.93,543a144.1,144.1,0,0,0,8.44,11.77,3.27,3.27,0,0,1-.47,4.7l-1.21.95a3.27,3.27,0,0,1-4.66-.65,36.93,36.93,0,0,0-10-9.47,3.27,3.27,0,0,1-.3-5.34l3.45-2.72A3.27,3.27,0,0,1,616.93,543Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#565388"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M687.59,577c-4-5.63-3.24-10.09-3.24-10.09L658,571.29a85,85,0,0,1,4.5,12.63A24.76,24.76,0,0,0,687.59,577Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.34,
    cy: 472.73,
    r: 24.77,
    fill: "#ffbdc6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M658.28,546.3c2.34-.39,4.42-1.76,6.79-1.88,3-.15,5.71,1.77,7.82,3.75s4.16,4.24,7.06,5.1a17.46,17.46,0,0,0,5.66.38,5.26,5.26,0,0,0,3-.76,3.78,3.78,0,0,0,1-1.53,14.55,14.55,0,0,0-.09-11.79,2,2,0,0,1-.28-1.28,1.94,1.94,0,0,1,.43-.71c2-2.36,4.11-4.72,4.92-7.58s-.18-6.38-3.13-7.65a5.89,5.89,0,0,0-4.66,0c-1.38.63-2.45,1.8-4,2.11-2.51.52-4.66-1.5-6.62-3a19.87,19.87,0,0,0-10.51-3.92,10.18,10.18,0,0,0-4.91.65,19.62,19.62,0,0,0-4,3c-4.47,3.61-10.73,4.62-16.33,6.59-1.07.38-2.26.94-2.46,2s1,2.13,2.2,2.59,2.58.76,3.38,1.69c1,1.2.68,2.9.86,4.41.37,3,3,4.63,5.91,5.5C652.73,544.74,655.89,546.7,658.28,546.3Z",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M658.28,545.68c2.34-.39,4.42-1.76,6.79-1.88,3-.15,5.71,1.77,7.82,3.75s4.16,4.24,7.06,5.1a17.46,17.46,0,0,0,5.66.38,5.26,5.26,0,0,0,3-.76,3.78,3.78,0,0,0,1-1.53,14.55,14.55,0,0,0-.09-11.79,2,2,0,0,1-.28-1.28,1.94,1.94,0,0,1,.43-.71c2-2.36,4.11-4.72,4.92-7.58s-.18-6.38-3.13-7.65a5.89,5.89,0,0,0-4.66,0c-1.38.63-2.45,1.8-4,2.11-2.51.52-4.66-1.5-6.62-3A19.87,19.87,0,0,0,665.81,517a10.18,10.18,0,0,0-4.91.65,19.62,19.62,0,0,0-4,3c-4.47,3.61-10.73,4.62-16.33,6.59-1.07.38-2.26.94-2.46,2s1,2.13,2.2,2.59,2.58.76,3.38,1.69c1,1.2.68,2.9.86,4.41.37,3,3,4.63,5.91,5.5C652.73,544.12,655.89,546.08,658.28,545.68Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#a66477"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M638.29,664.84s17.69,3,22.11,12.55,31,35.39,31,35.39",
    transform: "translate(-104.84 -86.48)",
    opacity: 0.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.54,702.28c-2.79,1.24-30.66-7.43-30.66-7.43a29.59,29.59,0,0,1,.09-8.11c-1.6,3.86-.71,10.28-.71,10.28s27.87,8.67,30.66,7.43c.92-.41,1.81-2.79,2.59-5.8C582.89,700.58,582.23,702,581.54,702.28Z",
    transform: "translate(-104.84 -86.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.4,622.63a18.25,18.25,0,0,0-.58,1.92s-6.72,40.13-10.73,55C557.8,667.48,564.8,626.2,565.4,622.63Z",
    transform: "translate(-104.84 -86.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.62,725.82s-20.75-30-19.82-44c0,0-.22,1.74-.61,4.2C587.13,700.66,606,728,606,728c14.43,0,20.88-10.22,23.67-20.95C626.59,716.93,620.08,725.82,606.62,725.82Z",
    transform: "translate(-104.84 -86.48)"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M553.17,697.91s18.92,10.42,25.74,5.46,2.48-12.7,2.48-12.7L576.12,682H558.47l-5.88,10.22Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#7679b4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M682.19,738.83s1.24-24.77-30.35-24.46-1.24,0-1.24,0-12.39-3.72-27.87,5-33.14,6.81-33.14,6.81-14.25,23.54-.93,30.35S606.31,754,606.31,754s27.25,5.26,33.45-1.86A31.79,31.79,0,0,0,674.13,759S689.62,752.14,682.19,738.83Z",
    transform: "translate(-104.84 -86.48)",
    fill: "#7679b4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.963dcbc5b76f9ae980aa430b80889f82.svg";
export { ForwardRef as ReactComponent };